import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteAllDepartments as apiForceDeleteAll } from "../../api/apiDepartments";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteAllDepartments() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: forceDeleteAllDepartments, isPending: isForceDelete } = useMutation({
        mutationFn: (req) => apiForceDeleteAll(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["departments"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { forceDeleteAllDepartments, isForceDelete };
}
